var map = {
	"./banner_1_br.png": 5849,
	"./banner_1_id.png": 1734,
	"./banner_1_in.png": 9964,
	"./banner_2_br.png": 3524,
	"./banner_2_id.png": 3435,
	"./banner_2_in.png": 9182,
	"./banner_3_br.png": 1883,
	"./banner_3_id.png": 296,
	"./banner_3_in.png": 2322,
	"./banner_4_br.png": 286,
	"./banner_4_id.png": 237,
	"./banner_4_in.png": 5703,
	"./banner_5_br.png": 5053,
	"./banner_5_id.png": 4018,
	"./banner_5_in.png": 8968,
	"./banner_6_br.png": 2040,
	"./banner_6_id.png": 8439,
	"./banner_6_in.png": 205,
	"./banner_7_id.png": 4340,
	"./banner_7_in.png": 7294,
	"./betRefund/betReFund_icon.png": 3385,
	"./betRefund/box_icon.png": 9381,
	"./bottomActive/bottom_select.png": 4308,
	"./gold_icon.png": 4514,
	"./invite/box_1.png": 3879,
	"./invite/box_2.png": 5148,
	"./invite/box_3.png": 2661,
	"./invite/btn_filter_0.png": 5102,
	"./invite/btn_filter_1.png": 3415,
	"./invite/invite_bg.png": 1971,
	"./invite/point_icon.png": 8256,
	"./invite/question_icon.png": 2028,
	"./invite/reward_active_bg.png": 7994,
	"./invite/reward_bg.png": 2217,
	"./invite/user_icon.png": 8415,
	"./line.png": 716,
	"./lossRefund/icon_1.png": 9473,
	"./lossRefund/icon_2.png": 8362,
	"./lossRefund/icon_3.png": 6115,
	"./newPlayer/amount_bg.png": 682,
	"./newPlayer/btn_des.png": 6765,
	"./newPlayer/cash_amount_br.png": 5121,
	"./newPlayer/cash_amount_id.png": 6798,
	"./newPlayer/cash_amount_in.png": 3844,
	"./newPlayer/cash_btn.png": 6126,
	"./newPlayer/cash_btn1.png": 4709,
	"./newPlayer/cash_des_br.png": 1107,
	"./newPlayer/cash_des_id.png": 3040,
	"./newPlayer/cash_des_in.png": 7274,
	"./newPlayer/cash_item.png": 9601,
	"./newPlayer/cash_item_bg.png": 9199,
	"./newPlayer/cash_item_complete_br.png": 7028,
	"./newPlayer/cash_item_complete_id.png": 9019,
	"./newPlayer/cash_item_complete_in.png": 2801,
	"./newPlayer/cash_item_treasure.png": 9257,
	"./newPlayer/cash_max_br.png": 4393,
	"./newPlayer/cash_max_id.png": 2518,
	"./newPlayer/cash_max_in.png": 7468,
	"./newPlayer/cashs_bg.png": 7428,
	"./newPlayer/pop/bg.png": 6663,
	"./newPlayer/pop/cash_tip_2_br.png": 9343,
	"./newPlayer/pop/cash_tip_2_id.png": 2372,
	"./newPlayer/pop/cash_tip_2_in.png": 7966,
	"./newPlayer/pop/cash_tip_3_br.png": 8344,
	"./newPlayer/pop/cash_tip_3_id.png": 9015,
	"./newPlayer/pop/cash_tip_3_in.png": 9725,
	"./newPlayer/pop/cash_tip_arrow.png": 5335,
	"./proxy/left_icon.png": 8040,
	"./proxy/left_icon1.png": 6163,
	"./proxy/myGold_bg.png": 4499,
	"./proxy/proxyDes.png": 8385,
	"./proxy/proxy_tables.png": 7005,
	"./proxy/shareIcons/icon_1.png": 2662,
	"./proxy/shareIcons/icon_2.png": 4429,
	"./proxy/shareIcons/icon_3.png": 1188,
	"./proxy/shareIcons/icon_4.png": 5995,
	"./proxy/shareIcons/icon_5.png": 4450,
	"./proxy/shareIcons/icon_6.png": 2633,
	"./proxy/shareIcons/icon_7.png": 8432,
	"./proxy/shareIcons/icon_8.png": 2663,
	"./success_icon.png": 6097,
	"./vip/btn_up.png": 3258,
	"./vip/header_icon.png": 8077,
	"./vip/line_left.png": 6946,
	"./vip/line_right.png": 7279,
	"./vip/lock_icon.png": 3315,
	"./vip/pager_bg.png": 3035,
	"./vip/pager_from.png": 2546,
	"./vip/pager_icon.png": 4073,
	"./vip/pager_icon_active.png": 8068,
	"./vip/process_bar.png": 3585,
	"./vip/process_bar1.png": 2428,
	"./vip/rleItem_bg.png": 8286,
	"./vip/role_bg.png": 5950,
	"./vip/role_icon_0_1.png": 9605,
	"./vip/role_icon_0_2.png": 7806,
	"./vip/role_icon_0_3.png": 823,
	"./vip/role_icon_1.png": 8132,
	"./vip/role_icon_1_1.png": 5220,
	"./vip/role_icon_1_2.png": 9711,
	"./vip/role_icon_1_3.png": 694,
	"./vip/role_icon_2.png": 591,
	"./vip/role_icon_3.png": 5494,
	"./vip/role_icon_4.png": 473,
	"./vip/role_icon_A_1.png": 4420,
	"./vip/role_icon_A_2.png": 9071,
	"./vip/role_icon_A_3.png": 2742,
	"./vip/role_icon_A_4.png": 8921,
	"./vip/role_icon_fail.png": 9081,
	"./vip/role_icon_normal.png": 5996,
	"./vip/role_icon_right.png": 6399,
	"./vip/role_tip_bg.png": 3220,
	"./vip/vip_info_bg_A.png": 1202,
	"./vip/vip_info_bg_B.png": 7785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4100;